<form [formGroup]="form">
  <label>
    <strong class="pr-1">{{ "SERIAL_NUMBER" | translate }}</strong>
    <span [matTooltip]="'ENTER_NIGHTOWL_ID' | translate" class="fa fa-fw fa-circle-info"></span>
  </label>

  <input
    class="form-control"
    type="text"
    name="serialNumber"
    formControlName="nightowlId"
    [placeholder]='("SERIAL_NUMBER" | translate) + " (NUAxxxxx)"'
    >
    @if (form.get('nightowlId')?.invalid && form.get('nightowlId')?.touched) {
      <small class="text-danger font-italic">
        {{ "SERIAL_NUMBER_FORMAT_ERROR" | translate }} <strong>NUAxxxxx</strong>
      </small>
    }

    @if (form.get('lyraId').value) {
      <label class="mt-3"><strong>Lyra ID</strong></label>
      <input class="form-control" type="text" formControlName="lyraId" name="lyraId">
      @if (hasMultipleCustomerIds()) {
        <div class="mt-3">
          <div class="form-group">
            <label><strong>{{'NIGHTOWL_CUSTOMER_ID' | translate}}</strong></label>
          </div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="customerId">
              <mat-option [value]="''">{{ 'SELECT_NIGHTOWL_CUSTOMER_ID' | translate }}</mat-option>
              @for (customerId of customerIds; track customerId) {
                <mat-option [value]="customerId.id">
                  {{ customerId.name ? customerId.name : customerId.id }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div>
        <div class="form-group">
          <label><strong>{{'LOCATION' | translate}}</strong></label>
        </div>
        <mat-form-field appearance="outline">
          <mat-select formControlName="locationId">
            <mat-option [value]="''">{{ 'LOCATION' | translate }}</mat-option>
            @for (location of locations; track location) {
              <mat-option [value]="location.id">
                {{ location.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <label><strong>{{ "NAME" | translate }}</strong></label>
      <input class="form-control" type="text" [placeholder]='"NAME" | translate' formControlName="deviceName" name="name">
    }

    <div class="form-group mt-4">
      @if (!form.get('lyraId').value) {
        <button
          type="button"
          class="btn btn-outline-primary gray-bg mr-1"
          data-testid="verify-button"
          [disabled]="form.get('nightowlId').invalid"
          (click)="verifyId()"
          >
          <i [ngClass]="showSpinner ? 'fas fa-circle-notch fa-spin mr-1' : 'fa-light fa-check'"></i>
          {{ (showSpinner ? "VERIFYING" : "VERIFY") | translate }}
        </button>
      } @else {
        <button
          type="button"
          data-testid="submit-button"
          class="btn btn-primary"
          [disabled]="form.invalid || !form.controls.nightowlId.value || !form.controls.lyraId || showSpinner"
          (click)="submit()"
          >
          <i [ngClass]="showSpinner ? 'fad fa-spinner-third fa-spin mr-2' : 'fa-light fa-floppy-disk mr-1'"></i>
          {{ (showSpinner ? "SAVING" : "SAVE") | translate }}
        </button>
        <button type="button" data-testid="cancel-button" class="btn btn-outline-primary gray-bg ml-3" [disabled]="showSpinner" (click)="clearForm()">
          <i class="fa-light fa-xmark"></i>
          {{ "CLEAR_FORM" | translate }}
        </button>
      }

    </div>
  </form>
